import asyncActionType from "../../utils/asyncActionType";

// ---------------------------------------------------------------------------
//  SHIPMENTS
// ---------------------------------------------------------------------------
export const FETCH_SHIPMENTS = asyncActionType("FETCH_SHIPMENTS");
export const FETCH_SHIPMENT = asyncActionType("FETCH_SHIPMENT");
export const CREATE_SHIPMENT = asyncActionType("CREATE_SHIPMENT");
export const UPDATE_SHIPMENT = asyncActionType("UPDATE_SHIPMENT");
export const FETCH_DESTINATIONS = asyncActionType("FETCH_DESTINATIONS");

// ---------------------------------------------------------------------------
//  PACKAGES
// ---------------------------------------------------------------------------
export const FETCH_PACKAGE_TYPES = asyncActionType("FETCH_PACKAGE_TYPES");
export const CREATE_PACKAGE = asyncActionType("CREATE_PACKAGE");
export const DELETE_PACKAGE = asyncActionType("DELETE_PACKAGE");
export const ADD_PACKAGE_TO_STATE = "ADD_PACKAGE_TO_STATE";
export const DELETE_PACKAGE_FROM_STATE = "DELETE_PACKAGE_FROM_STATE";
export const ADD_ITEM_TO_PACKAGE = "ADD_ITEM_TO_PACKAGE";
export const DELETE_ITEM_FROM_PACKAGE = "DELETE_ITEM_FROM_PACKAGE";

// ---------------------------------------------------------------------------
//  RETURNS
// ---------------------------------------------------------------------------
export const CREATE_RETURN = asyncActionType("CREATE_RETURN");
export const FETCH_RETURN = asyncActionType("FETCH_RETURN");
export const FETCH_RETURNS = asyncActionType("FETCH_RETURNS");
export const FETCH_RETURN_CATEGORIES = asyncActionType("FETCH_RETURN_CATEGORIES");
